import shift4Logo from '../../../assets/shift4Logo.svg';
import styles from './PreAuthenticationDetails.module.scss';
import { useTranslation } from '../../hooks/useTranslation';

interface IPreAuthFooterProps {
	defaultTipPercentageValue: number | boolean | undefined;
}

const PreAuthFooter: React.FC<IPreAuthFooterProps> = ({ defaultTipPercentageValue }) => {
	const { t } = useTranslation();

	return (
		<div className={styles.preAuthFooter} id="preAuthFooter">
			<p className={styles.subText}>
				{defaultTipPercentageValue
					? t('page:preAuthFooter:agreementWithTip:text', { tipPercentage: Number(defaultTipPercentageValue) })
					: t('page:preAuthFooter:agreementWithoutTip:text')
				}
			</p>
			<div className={styles.logoContainer}>
				<img src={shift4Logo} alt="shift4 logo" />
			</div>
		</div>
	);
};

export default PreAuthFooter;
